import Image from "next/image";
import Breadcrumbs from "../ui/Breadcrumbs";
import { useRouter } from "next/router";

// interface ServicesHeroProps {
//   pageTitle: string;
//   image: string;
//   text: string;
//   serviceTitle: string;
// }

const ServicesHero = ({
  pageTitle,
  image,
  text,
  serviceTitle,
  breadcrumbsTitle,
}) => {



  const router = useRouter()
  const { locale } = router   

  return (
    <section className="container-max w-full overflow-hidden relative">
      <div className="container-padding">
        <div className="flex flex-col w-full">
          <div className="w-full py-[2rem] lg:pt-[2.4rem] xl:pt-[4rem]">
            <Breadcrumbs
              items={locale === 'ru' ? [
                { label: "ГЛАВНАЯ", href: "/" },
                { label: breadcrumbsTitle, href: "/uslugi" },
              ] : [
                { label: "HOME", href: "/" },
                { label: breadcrumbsTitle, href: "/uslugi" },
              ]}
              separator="/"
              itemClassName="text-base tracking-wide"
              linkClassName="text-[#bda76a]"
              currentClassName="text-[#0f1626]"
              separatorClassName="text-[#bda76a]"
            />
          </div>

          <div className="w-full flex-col pt-[1.6rem] pb-[2.4rem] md:pt-[2rem] lg:pb-[2.8rem] xl:pt-[4rem] xl:pb-[6rem]">
            <div>
              <h1 className="heading-2 text-[3.6rem] wrap-break-word md:text-[5.2rem] lg:text-[6rem] xl:text-[8rem] lg:max-w-[87.2rem] xl:max-w-[116rem] md:max-w-[72rem] mb-[1.6rem] lg:mb-[2.4rem] xl:mb-[3.6rem]">
                {pageTitle}
              </h1>
              <div className="flex flex-col lg:flex-row">
                <p className="text-1 max-w-[42.6rem] mb-[4rem] lg:mb-0 text-dark-blue">
                  {text}
                </p>

                <div className="w-full flex justify-end">
                  <h2 className="heading-3 text-right max-w-[32rem] lg:max-w-[47rem] xl:max-w-[57rem] [&>.selected]:italic [&>.selected]:text-dusty-green-dark" dangerouslySetInnerHTML={{__html: serviceTitle}}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full relative h-[26rem] md:h-[32rem] lg:md:h-auto lg:aspect-[4.5]">
        <Image
          src={image?.url}
          alt={image?.alt}
          fill
          fetchPriority="high"
          priority={true}
          sizes="100vw"
          className="w-auto object-cover"
        />
      </div>
    </section>
  );
};

export default ServicesHero;
